const updateCartCount = (count) => {
  const cartCountEls = document.querySelectorAll('[data-cart-count]');
  if (!cartCountEls.length) return;

  cartCountEls.forEach(cartCountEl => {
    cartCountEl.textContent = count;
  });
};

export default updateCartCount;
